import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

const Header = () => {
  const location = useLocation();
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [carsDropdownOpen, setCarsDropdownOpen] = useState(false);
  const [stickyHeader, setStickyHeader] = useState(false);

  // Toggle body class for mobile menu
  useEffect(() => {
    if (mobileMenuOpen) {
      document.body.classList.add('mobile-menu-visible');
    } else {
      document.body.classList.remove('mobile-menu-visible');
    }
  }, [mobileMenuOpen]);



  const isActive = (path) => location.pathname === path ? 'current' : '';
  const isCarsActive = () => {
    const carPages = ['/swift-dzire', '/maruti-ertiga', '/innova-crysta', '/force-urbania', '/tempo-traveller', '/bus-56seater'];
    return carPages.includes(location.pathname) ? 'current' : '';
  };

  return (
    <header id="header3" className="main-header header header-fixed">
      {/* Top Bar */}
      <div className="top-bar">
        <div className="themesflat-container">
          <div className="row">
            <div className="col-md-9">
              <ul className="list-infor-topbar">
                <li>
                  <a href="tel:+917801904444">
                    <i className="icon-Group-11"></i>
                    <p>call: +91 7801904444</p>
                  </a>
                </li>
                <li>
                  <a href="mailto:info@cabexperience.com">
                    <i className="icon-Group3"></i>
                    <p>Mail Us: info@cabexperience.com</p>
                  </a>
                </li>
              </ul>
            </div>
            <div className="col-md-3">
              <ul className="icon-topbar">
                <li><a href="#"><i className="icon-6"></i></a></li>
                <li><a href="#"><i className="icon-4"></i></a></li>
                <li><a href="#"><i className="icon-5"></i></a></li>
                <li><a href="#"><i className="icon-7"></i></a></li>
              </ul>
            </div>
          </div>
        </div>
      </div>

      {/* Header Lower */}
      <div className="header-lower">
        <div className="themesflat-container">
          <div className="row">
            <div className="col-lg-12">
              <div className="header-style2 flex justify-space align-center">
                {/* Logo */}
                <div className="logo-box flex">
                  <div className="logo">
                    <Link to="/">
                      <img src="/assets/images/logo/logo.png" alt="Cab Experience - Car Rental Rajkot Logo" />
                    </Link>
                  </div>
                </div>

                {/* Navigation */}
                <div className="nav-outer flex align-center">
                  <nav className="main-menu show navbar-expand-md">
                    <div className="navbar-collapse collapse clearfix" id="navbarSupportedContent">
                      <ul className="navigation clearfix">
                        <li className={isActive('/')}>
                          <Link to="/">Home</Link>
                        </li>
                        <li className={isActive('/about-us')}>
                          <Link to="/about-us">About Us</Link>
                        </li>
                        <li className={`dropdown2 ${isCarsActive()}`}>
                          <a href="#">Our Cars</a>
                          <ul>
                            <li><Link to="/swift-dzire">Swift Dzire</Link></li>
                            <li><Link to="/maruti-ertiga">Maruti Ertiga</Link></li>
                            <li><Link to="/innova-crysta">Innova Crysta</Link></li>
                            <li><Link to="/force-urbania">Force Urbania</Link></li>
                            <li><Link to="/tempo-traveller">Tempo Traveller</Link></li>
                            <li><Link to="/bus-56seater">56-Seater Bus</Link></li>
                          </ul>
                        </li>
                        <li className={isActive('/book-a-car')}>
                          <Link to="/book-a-car">Book A Car</Link>
                        </li>
                        <li className={isActive('/contact-us')}>
                          <Link to="/contact-us">Contact us</Link>
                        </li>
                      </ul>
                    </div>
                  </nav>
                </div>

                {/* Inquiry Button */}
                <div className="header-account flex align-center">
                  <div className="flat-bt-top sc-btn-top ml--20">
                    <Link className="btn-icon-list" to="/contact-us">
                      <span>Inquiry</span>
                    </Link>
                  </div>
                </div>

                {/* Mobile Menu Toggle */}
                <div className="mobile-nav-toggler mobile-button" onClick={() => setMobileMenuOpen(!mobileMenuOpen)}>
                  <span></span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Sticky Header */}
      <div className="sticky-header">
        <div className="themesflat-container">
          <div className="row">
            <div className="col-lg-12">
              <div className="header-style2 flex justify-space align-center">
                <div className="logo-box flex">
                  <div className="logo">
                    <Link to="/">
                      <img src="/assets/images/logo/logo.png" alt="Cab Experience" />
                    </Link>
                  </div>
                </div>
                {/* Mobile Menu Toggle for Sticky */}
                <div className="mobile-nav-toggler mobile-button" onClick={() => setMobileMenuOpen(!mobileMenuOpen)}>
                  <span></span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Mobile Menu */}
      {mobileMenuOpen && (
        <div className="close-btn" onClick={() => setMobileMenuOpen(false)}>
          <span className="icon flaticon-cancel-1"></span>
        </div>
      )}
      <div className={`mobile-menu ${mobileMenuOpen ? 'active' : ''}`}>
        <div className="menu-backdrop" onClick={() => setMobileMenuOpen(false)}></div>
        <nav className="menu-box">
          <div className="nav-logo">
            <Link to="/" onClick={() => setMobileMenuOpen(false)}>
              <img src="/assets/images/logo/logo.png" alt="Cab Experience - Car Rental Rajkot" />
            </Link>
          </div>
          <div className="bottom-canvas">
            <div className="menu-outer">
              <ul className="navigation clearfix">
                <li className={isActive('/')}>
                  <Link to="/" onClick={() => setMobileMenuOpen(false)}>Home</Link>
                </li>
                <li className={isActive('/about-us')}>
                  <Link to="/about-us" onClick={() => setMobileMenuOpen(false)}>About Us</Link>
                </li>
                <li className={`dropdown2 ${carsDropdownOpen ? 'open' : ''} ${isCarsActive()}`}>
                  <a href="#" onClick={(e) => { e.preventDefault(); setCarsDropdownOpen(!carsDropdownOpen); }}>Our Cars</a>
                  <ul style={{ display: carsDropdownOpen ? 'block' : 'none' }}>
                    <li><Link to="/swift-dzire" onClick={() => setMobileMenuOpen(false)}>Swift Dzire</Link></li>
                    <li><Link to="/maruti-ertiga" onClick={() => setMobileMenuOpen(false)}>Maruti Ertiga</Link></li>
                    <li><Link to="/innova-crysta" onClick={() => setMobileMenuOpen(false)}>Innova Crysta</Link></li>
                    <li><Link to="/force-urbania" onClick={() => setMobileMenuOpen(false)}>Force Urbania</Link></li>
                    <li><Link to="/tempo-traveller" onClick={() => setMobileMenuOpen(false)}>Tempo Traveller</Link></li>
                    <li><Link to="/bus-56seater" onClick={() => setMobileMenuOpen(false)}>56-Seater Bus</Link></li>
                  </ul>
                  <div className="dropdown2-btn" onClick={() => setCarsDropdownOpen(!carsDropdownOpen)}></div>
                </li>
                <li className={isActive('/book-a-car')}>
                  <Link to="/book-a-car" onClick={() => setMobileMenuOpen(false)}>Book A Car</Link>
                </li>
                <li className={isActive('/contact-us')}>
                  <Link to="/contact-us" onClick={() => setMobileMenuOpen(false)}>Contact Us</Link>
                </li>
              </ul>
            </div>
          </div>
        </nav>
      </div>
    </header>
  );
};

export default Header;
